import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type DeleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDeleteData,
  type DeleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDeleteError,
  type DeleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDeleteResponse,
  deleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDelete,
} from '../../generated';

export type DeleteRoleAssignmentMutationVariables =
  DeleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDeleteData['path'];

export type DeleteRoleAssignmentMutation = DeleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDeleteResponse;

export const useDeleteRoleAssignmentMutation = <
  TError = DeleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDeleteError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<DeleteRoleAssignmentMutation, TError, DeleteRoleAssignmentMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<DeleteRoleAssignmentMutation, TError, DeleteRoleAssignmentMutationVariables, TContext>({
    mutationKey: ['DeleteRoleAssignment'],
    mutationFn: async ({ role_assignment_id }: DeleteRoleAssignmentMutationVariables) => {
      const { data } = await deleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDelete({
        path: { role_assignment_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useDeleteRoleAssignmentMutation.fetcher = (
  { role_assignment_id }: DeleteRoleAssignmentMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await deleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDelete({
      path: { role_assignment_id },
      throwOnError: true,
    });
    return data;
  };
};
